module.exports = __webpack_public_path__ + "static/media/INTP.7abcd7dc.png";